import * as types from '../constants/ActionTypes';

// Update Message us eligibility and wait time into redux state
const updateLexaMessage = ({ available, waitTime }) => ({
  type: types.UPDATE_LEXA_MESSAGE,
  payload: { available, waitTime },
});

module.exports = {
  updateLexaMessage,
};
